// The Collection Store's three tabs, in display order.
export const COLLECTION_TABS = [
  { key: 'guardians', label: 'Guardians' },
  { key: 'relics', label: 'Relics' },
  { key: 'badges', label: 'Badges' },
];

export const DEFAULT_COLLECTION_TAB = 'guardians';

/**
 * During the guided first visit the store shows only the tour's badges (owner round 4; Sol onboarding-leftovers L3 A):
 * Slide Explorer, First Friend, Quiz Starter and Ready to Explore. A view only - ownership data is untouched.
 */
export const TOUR_BADGE_IDS = ['WEL-001', 'AIT-001', 'WEL-003', 'WEL-002'];
export const TOUR_COLLECTION_TABS = COLLECTION_TABS.filter(entry => entry.key === 'badges');
export function tourOnlyCatalog(catalog) {
  if (!catalog) return catalog;
  const keep = badge => TOUR_BADGE_IDS.includes(badge?.badgeId);
  return {
    ...catalog,
    badges: (catalog.badges || []).filter(keep),
    badgeCategories: (catalog.badgeCategories || [])
      .map(category => ({ ...category, badges: (category.badges || []).filter(keep) }))
      .filter(category => category.badges.length > 0),
  };
}
